import {
  HttpRequest,
  HttpHandlerFn,
  HttpEvent,
  HttpErrorResponse,
} from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { environment } from "../../../environments/environment";

export function authInterceptor(
  request: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> {
  // 인증이 필요한 요청인지 확인
  if (isAuthRequired(request.url)) {
    const token = getAuthToken();
    if (token) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
        },
      });
    }
  }

  return next(request).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        // 토큰이 만료되었거나 유효하지 않은 경우
        clearAuthData();
        // 로그인 페이지로 리다이렉트
        window.location.href = "/auth/login";
      }
      return throwError(() => error);
    })
  );
}

function isAuthRequired(url: string): boolean {
  // 인증이 필요하지 않은 엔드포인트들
  const publicEndpoints = [
    "/api/auth/login",
    "/api/auth/signup",
    "/api/auth/forgot-password",
    "/api/auth/refresh",
    "/api/users/emailLogin",
  ];

  return !publicEndpoints.some((endpoint) => url.includes(endpoint));
}

function getAuthToken(): string | null {
  return localStorage.getItem(environment.auth.tokenKey);
}

function clearAuthData(): void {
  localStorage.removeItem(environment.auth.tokenKey);
  localStorage.removeItem(environment.auth.refreshTokenKey);
  localStorage.removeItem(environment.auth.tokenExpiryKey);
  localStorage.removeItem("currentUser");
}
